import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { getLocation } from '../../services/locationService';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import Tabs from '../../components/ui/Tabs';
import LocationEmployeesTab from './tab-pages/LocationEmployeesTab';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StickyHeader = styled.div`
  flex-shrink: 0;
`;

const TabContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-top: 8px;
`;

export default function LocationDetailsPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const [location, setLocation] = useState(null);
  const [activeTab, setActiveTab] = useState('employees');

  useEffect(() => {
    getLocation(id)
      .then((res) => setLocation(res.data?.data))
      .catch(() => {});
  }, [id]);

  const tabs = [
    { key: 'employees', label: t('location.employees') },
  ];

  return (
    <PageContainer>
      <StickyHeader>
        <Breadcrumbs items={[
          { label: t('location.title'), path: '/locations' },
          { label: location?.name || '...' },
        ]} />

        <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />
      </StickyHeader>

      <TabContent>
        {activeTab === 'employees' && <LocationEmployeesTab locationId={id} />}
      </TabContent>
    </PageContainer>
  );
}
